import React from 'react';
import { Controller } from 'react-hook-form';
import { InputSwitch } from 'primereact/inputswitch';
import { RadioButton } from 'primereact/radiobutton';
import { useHistory } from 'react-router-dom';

import ImageComponent from 'shared/ImageComponent';
import { handleRedirection } from 'utils/utils';

function SelectedFirmUsers(props) {
  const { selectedAttendees, control, watch, setValue } = props;
  const history = useHistory();
  const firmUsers = watch('firm_users') || selectedAttendees;

  const handleSendReminderChange = (id, value) => {
    const updatedUsers = [...firmUsers];
    updatedUsers[id].send_reminder = value;
    setValue('firm_users', updatedUsers);
  };

  return (
    <div className="d-flex align-items-center py-2">
      <div className="col-12">
        {/* Desktop Table */}
        <div className="selected-firm-users-table d-none d-md-block">
          <table className="table attendees-table">
            <thead>
              <tr>
                <th className="attendee-names">Firm Users</th>
                <th className="text-center">
                  <label className="text-muted">Required</label>
                </th>
                <th className="text-center">
                  <label className="text-muted">Optional</label>
                </th>
                <th className="text-center">
                  <label className="text-muted">Send Reminder</label>
                </th>
              </tr>
            </thead>
            <tbody>
              {selectedAttendees?.map((item, id) => {
                return (
                  <tr key={id}>
                    <td className="attendee-names">
                      <div
                        className="d-flex redirection-link-no-text-transform"
                        onClick={() => {
                          let url = '/settings/team-management';
                          if (item?.firm_user_id) url = `/settings/team-management/${item?.firm_user_id}`;
                          handleRedirection(history, url);
                        }}
                      >
                        <ImageComponent filePath={item?.profile_image} fileName={item.name} fileSize="small.jpg" />
                        <div className="mx-2 align-items-center d-flex">{item.name}</div>
                      </div>
                    </td>
                    <Controller
                      name={`firm_users.${id}.is_attendance_required`}
                      control={control}
                      defaultValue="optional"
                      render={({ field }) => (
                        <>
                          <td className="text-center">
                            <div>
                              <RadioButton
                                inputId={`firm-required-${id}`}
                                name={field.name}
                                value="required"
                                checked={field.value === 'required'}
                                onChange={(e) => field.onChange(e.value)}
                              />
                            </div>
                          </td>
                          <td className="text-center">
                            <div className="p-field-radiobutton">
                              <RadioButton
                                inputId={`firm-optional-${id}`}
                                name={field.name}
                                value="optional"
                                checked={field.value === 'optional'}
                                onChange={(e) => field.onChange(e.value)}
                              />
                            </div>
                          </td>
                        </>
                      )}
                    />
                    <Controller
                      name={`firm_users.${id}.send_reminder`}
                      control={control}
                      render={({ field }) => (
                        <td className="text-center">
                          <InputSwitch
                            id={field.name}
                            value={field.value}
                            checked={field.value}
                            onChange={(e) => {
                              field.onChange(e.value);
                              handleSendReminderChange(id, e.value);
                            }}
                            placeholder="Meeting URL"
                          />
                        </td>
                      )}
                    />
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* Mobile Responsive Card List */}
        <div className="selected-firm-users-mobile d-block d-md-none">
          {selectedAttendees?.map((item, id) => (
            <div className="firm-user-mobile-row d-flex flex-wrap mb-3 p-2 firm-user-mobile-gap" key={id}>
              <div className="col-4 firm-user-mobile-label">Firm User</div>
              <div className="col-8 d-flex align-items-center">
                <div
                  className="d-flex redirection-link-no-text-transform"
                  onClick={() => {
                    let url = '/settings/team-management';
                    if (item?.firm_user_id) url = `/settings/team-management/${item?.firm_user_id}`;
                    handleRedirection(history, url);
                  }}
                >
                  <ImageComponent filePath={item?.profile_image} fileName={item.name} fileSize="small.jpg" />
                  <div className="mx-2 align-items-center d-flex">{item.name}</div>
                </div>
              </div>
              <div className="col-4 firm-user-mobile-label">Required</div>
              <div className="col-8 ">
                <Controller
                  name={`firm_users.${id}.is_attendance_required`}
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <RadioButton
                      inputId={`firm-required-mobile-${id}`}
                      name={field.name}
                      value="required"
                      checked={field.value === 'required'}
                      onChange={(e) => field.onChange(e.value)}
                    />
                  )}
                />
              </div>
              <div className="col-4 firm-user-mobile-label">Optional</div>
              <div className="col-8 ">
                <Controller
                  name={`firm_users.${id}.is_attendance_required`}
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <RadioButton
                      inputId={`firm-optional-mobile-${id}`}
                      name={field.name}
                      value="optional"
                      checked={field.value === 'optional'}
                      onChange={(e) => field.onChange(e.value)}
                    />
                  )}
                />
              </div>
              <div className="col-4 firm-user-mobile-label">Send Reminder</div>
              <div className="col-8 d-flex align-items-center">
                <Controller
                  name={`firm_users.${id}.send_reminder`}
                  control={control}
                  render={({ field }) => (
                    <InputSwitch
                      id={field.name}
                      value={field.value}
                      checked={field.value}
                      onChange={(e) => {
                        field.onChange(e.value);
                        handleSendReminderChange(id, e.value);
                      }}
                      placeholder="Meeting URL"
                    />
                  )}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SelectedFirmUsers;
